/**
 * Code transverse à toute l'application
 */


// Ajax calls should always have the CSRF token attached to them, otherwise
// they won't work
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

// To make Pace works on Ajax calls
Pace.options.ajax.trackWebSockets = false;
Pace.options.ajax.ignoreURLs = ['pusher'];
$(document).ajaxStart(function() {
  Pace.restart();
});

// polyfills
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

// Draw single points
Highcharts.wrap(Highcharts.Series.prototype, 'drawPoints', function(proceed) {
  // enable for all and filter the hidden by finding the point that should have
  // markers
  var markerState = this.options.marker.enabled,
      points      = this.points;

  this.options.marker.enabled = true;

  Highcharts.each(Highcharts.grep(points, function isValidPoint(point, i) {
    return !(!point.isNull &&
        // previous point is null or there's no previous point (the point is
        // first)
        ((points[i - 1] && points[i - 1].isNull) || !points[i - 1]) &&
        // next point is null or there's no next point (the point is last)
        ((points[i + 1] && points[i + 1].isNull) || !points[i + 1]));

  }), function(point) {
    if (point.marker) {
      point.marker.enabled = false;
    }
    else {
      point.marker = {
        enabled: false
      };
    }
  });

  proceed.call(this);

  // Reset
  this.options.marker.enabled = markerState;
});

// when document is ready
$(document).ready(function() {

  $.fn.extend({
    // TreeView
    treed: function(o) {

      var openedClass = 'glyphicon-minus-sign',
          closedClass = 'glyphicon-plus-sign';

      if (typeof o !== 'undefined') {
        if (typeof o.openedClass !== 'undefined') {
          openedClass = o.openedClass;
        }
        if (typeof o.closedClass !== 'undefined') {
          closedClass = o.closedClass;
        }
      }

      //initialize each of the top levels
      var tree = $(this);
      tree.addClass('tree');
      tree.find('li').has('ul').each(function() {
        var branch = $(this); //li with children ul
        branch.prepend('<i class=\'indicator glyphicon ' + closedClass +
            '\'></i>');
        branch.addClass('branch');
        branch.on('click', function(e) {
          if (this === e.target) {
            var icon = $(this).children('i:first');
            icon.toggleClass(openedClass + ' ' + closedClass);
            $(this).children('ul').children().toggle();
          }
        });
        branch.children('ul').children().toggle();
      });
      //fire event from the dynamically added icon
      tree.find('.branch .indicator').each(function() {
        $(this).on('click', function() {
          $(this).closest('li').click();
        });
      });
    }
  });

  // iCheck
  $('input').iCheck({
    checkboxClass: 'icheckbox_minimal-blue',
    radioClass:    'iradio_minimal-blue',
    increaseArea:  '20%' // optional
  });

  // Sauvegarde de l'état ouvert/fermé des boxes
  function saveBoxStateInLocalStorage() {
    var box     = this.closest('.box'),
        boxname = $(box).data('name');
    if (boxname !== undefined) {
      var boxstates = localStorage.aqualis_box_state;
      if (!boxstates) {
        boxstates = [];
      }
      else {
        boxstates = JSON.parse(boxstates);
      }
      boxstates = $.grep(boxstates, function(n) {
        return n.boxname !== boxname;
      });
      boxstates.push({
        'boxname': boxname,
        'state':   $(box).hasClass('collapsed-box') ? 1 : 0
      });
      localStorage.aqualis_box_state = JSON.stringify(boxstates);
    }
  }

  $('.box').
      on('expanded.boxwidget collapsed.boxwidget', saveBoxStateInLocalStorage);

  //load states
  var boxstates = localStorage.aqualis_box_state;
  if (!boxstates) {
    boxstates = [];
  }
  else {
    boxstates = JSON.parse(boxstates);
  }
  boxstates.forEach(function(box) {
    if (box.state === 1) {
      $('.box[data-name="' + box.boxname + '"]').
          addClass('collapsed-box').
          find('.btn-box-tool[data-widget="collapse"] i').
          removeClass('fa-minus').
          addClass('fa-plus');
    }
    else if (box.state === 0) {
      $('.box[data-name="' + box.boxname + '"]').
          removeClass('collapsed-box').
          find('.btn-box-tool[data-widget="collapse"] i').
          removeClass('fa-plus').
          addClass('fa-minus');
    }
  });

  // date pickers
  $.fn.datepicker.defaults.todayBtn = 'linked';
  $.fn.datepicker.defaults.autoclose = true;
  $.fn.datepicker.defaults.toggleActive = true;

  // Select2
  $('.select2').select2();
  $(window).on('resize', function() {
    $('.select2').select2();
  });

  // comportement de la sidebar reduite
  $('[data-toggle="control-sidebar"]').controlSidebar();
  $('[data-toggle="push-menu"]').pushMenu({
    expandOnHover: false
  });
});

// when ajax request is complete
$(document).ajaxComplete(function() {
// iCheck
  $('input:not(.icheckbox_minimal-blue)').iCheck({
    checkboxClass: 'icheckbox_minimal-blue',
    radioClass:    'iradio_minimal-blue',
    increaseArea:  '20%' // optional
  });
  // select2
  $('.select2').select2();
});


// WEBPACK FOOTER //
// ./resources/assets/js/common.js